import React, { useState } from "react";
import { Grid } from "@material-ui/core";
import CalculatorTableMain from "./components/CalculatorTableMain/CalculatorTableMain";
import MainBottomFrame from "./components/BottomFrame/MainBottomFrame";
import CalculatorContainer from "../../containers/CalculatorContainer";
import { makeStyles } from "@material-ui/core/styles";
import Header from "../../../components/header/Header";
import Footer from "../../../components/footer/Footer";

const useStyles = makeStyles(() => ({
  root: {
    marginTop: '137px',
    '@media print': {
      marginTop: '75px',
    }
  }
}));

export default function PostCalculationMain() {
  const classes = useStyles();
  const tourIsShown = localStorage.getItem('tourIsShown') === 'true';

  const [isTourOpen, setIsTourOpen] = useState(!tourIsShown);
  const handleTourOpen = () => setIsTourOpen(true);
  const handleTourClose = () => {
    localStorage.setItem('tourIsShown', true);
    setIsTourOpen(false);
  }

  return (
    <>
      <Header handleTourOpen={handleTourOpen} />
      <Grid container justify="center" className={classes.root}>
        <CalculatorContainer margin="0 20px 10px 20px">
          <CalculatorTableMain isTourOpen={isTourOpen} handleTourClose={handleTourClose} />
        </CalculatorContainer>
        <CalculatorContainer>
          <MainBottomFrame />
        </CalculatorContainer>
      </Grid>
      <Footer />
    </>
  );
}
